/* eslint-disable eol-last */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [{
	path: '/404',
	name: 'notPage',
	component: resolve => require(['@/pages/error/index'], resolve),
	meta: {
		title: '主页',
		auth: true
	}
},
{
	path: '*',
	redirect: '/404'
},
{
	path: '/',
	redirect: '/home',
	component: resolve => require(['@/pages/App'], resolve),
	children: [
		{
			path: '/home',
			name: 'home',
			component: resolve => require(['@/pages/home/index'], resolve),
			meta: {
				title: '主页',
				auth: false
			}
		},
		{
			path: '/dataCenter',
			name: 'dataCenter',
			component: resolve => require(['@/pages/dataCenter/index'], resolve),
			meta: {
				title: '数据中心',
				auth: true,
				callOn: 2,
				cell: true,
			}
		},
		{
			path: '/statistics',
			name: 'statistics',
			component: resolve => require(['@/pages/statistics/index'], resolve),
			meta: {
				title: '统计分析',
				auth: false,
				callOn: 3,
				cell: true,
			}
		},
		{
			path: '/aboutUs',
			name: 'aboutUs',
			component: resolve => require(['@/pages/aboutUs/index'], resolve),
			meta: {
				title: '关于我们',
				auth: false,
			}
		},
		{
			path: '/infoManage',
			name: 'infoManage',
			component: resolve => require(['@/pages/infoManage/index'], resolve),
			meta: {
				title: '信息管理',
				auth: true
			}
		},
		{
			path: '/searchPage',
			name: 'searchPage',
			component: resolve => require(['@/pages/home/searchPage'], resolve),
			meta: {
				title: '搜索页面',
				auth: true,
				cell: true,
			}
		},
		{
			path: '/organizationDetails',
			name: 'organizationDetails',
			component: resolve => require(['@/pages/home/organizationDetails'], resolve),
			meta: {
				title: '机构详情',
				auth: true,
				callOn: 4
			}
		}
	]
}];
const router = new Router({
	mode: 'history',
	routes
})
router.beforeEach((to, from, next) => {
	let userLocalInfos = JSON.parse(localStorage.getItem('json_user_info'));
	// next()
	if (to.matched.some(record => record.meta.auth)) {
		if (!userLocalInfos) {
			next({
				path: '/',
			})
		} else {
			if (to.matched.some(record => record.meta.cell)) {
				if (userLocalInfos.user.role_id == 99) {
					
					next(false);
				} else {
					next()
				}
			} else {
				next()
			}
		}
	} else {
		next() // 确保一定要调用 next()
	}
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js